/**
 * Rute aplikasi.
 *
 * Catatan penting:
 *  - Halaman wajib ganti kata sandi (`/ganti-kata-sandi`) berada DI LUAR layout
 *    terautentikasi agar tetap terjangkau saat backend memblokir endpoint lain.
 *  - Ada SATU catch-all 404 di dalam layout terautentikasi.
 */
import { Route, Routes } from 'react-router-dom'
import { AuthProvider } from '@/lib/auth'
import { Layout, ToastProvider } from '@/components'

import Login from '@/pages/Login'
import GantiPassword from '@/pages/GantiPassword'
import Dashboard from '@/pages/Dashboard'
import Tagihan from '@/pages/Tagihan'
import DetailTagihan from '@/pages/DetailTagihan'
import Pembayaran from '@/pages/Pembayaran'
import Tunggakan from '@/pages/Tunggakan'
import KasMasuk from '@/pages/KasMasuk'
import KasKeluar from '@/pages/KasKeluar'
import KasBank from '@/pages/KasBank'
import Anggaran from '@/pages/Anggaran'
import KasKecil from '@/pages/KasKecil'
import TransferAntarunit from '@/pages/TransferAntarunit'
import Pertanggungjawaban from '@/pages/Pertanggungjawaban'
import Persetujuan from '@/pages/Persetujuan'
import Jurnal from '@/pages/Jurnal'
import BukuBesar from '@/pages/BukuBesar'
import NeracaSaldo from '@/pages/NeracaSaldo'
import Neraca from '@/pages/Neraca'
import LaporanAktivitas from '@/pages/LaporanAktivitas'
import ArusKas from '@/pages/ArusKas'
import LaporanKonsolidasi from '@/pages/LaporanKonsolidasi'
import Rekonsiliasi from '@/pages/Rekonsiliasi'
import Audit from '@/pages/Audit'
import MasterData from '@/pages/MasterData'
import PenggunaHakAkses from '@/pages/PenggunaHakAkses'
import Pengaturan from '@/pages/Pengaturan'
import PortalWali from '@/pages/PortalWali'
import Konten from '@/pages/Konten'
import Media from '@/pages/Media'
import PendaftarPPDB from '@/pages/PendaftarPPDB'
import NotFound from '@/pages/NotFound'

export default function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <Routes>
          {/* Di luar layout terautentikasi */}
          <Route path="/login" element={<Login />} />
          <Route path="/ganti-kata-sandi" element={<GantiPassword />} />

          {/* Layout terautentikasi + seluruh menu sidebar */}
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />

            <Route path="/tagihan" element={<Tagihan />} />
            <Route path="/tagihan/:id" element={<DetailTagihan />} />
            <Route path="/pembayaran" element={<Pembayaran />} />
            <Route path="/tunggakan" element={<Tunggakan />} />

            <Route path="/kas-masuk" element={<KasMasuk />} />
            <Route path="/kas-keluar" element={<KasKeluar />} />
            <Route path="/kas-bank" element={<KasBank />} />
            <Route path="/anggaran" element={<Anggaran />} />
            <Route path="/kas-kecil" element={<KasKecil />} />
            <Route path="/transfer-antarunit" element={<TransferAntarunit />} />
            <Route path="/pertanggungjawaban" element={<Pertanggungjawaban />} />
            <Route path="/persetujuan" element={<Persetujuan />} />

            <Route path="/jurnal" element={<Jurnal />} />
            <Route path="/buku-besar" element={<BukuBesar />} />
            <Route path="/neraca-saldo" element={<NeracaSaldo />} />
            <Route path="/neraca" element={<Neraca />} />
            <Route path="/laporan-aktivitas" element={<LaporanAktivitas />} />
            <Route path="/arus-kas" element={<ArusKas />} />
            <Route path="/laporan-konsolidasi" element={<LaporanKonsolidasi />} />
            <Route path="/rekonsiliasi" element={<Rekonsiliasi />} />

            <Route path="/audit" element={<Audit />} />
            <Route path="/master-data" element={<MasterData />} />
            <Route path="/pengguna-hak-akses" element={<PenggunaHakAkses />} />
            <Route path="/pengaturan" element={<Pengaturan />} />

            {/* Grup terpisah: Portal Wali */}
            <Route path="/portal" element={<PortalWali />} />

            {/* Konten website abduljalal.org & PPDB */}
            <Route path="/konten" element={<Konten />} />
            <Route path="/media" element={<Media />} />
            <Route path="/pendaftar-ppdb" element={<PendaftarPPDB />} />

            {/* Catch-all 404 */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </AuthProvider>
    </ToastProvider>
  )
}
